import { render, staticRenderFns } from "./sliderGoods.edit.vue?vue&type=template&id=1dde529c&scoped=true"
import script from "./sliderGoods.edit.vue?vue&type=script&lang=js"
export * from "./sliderGoods.edit.vue?vue&type=script&lang=js"
import style0 from "./sliderGoods.edit.vue?vue&type=style&index=0&id=1dde529c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dde529c",
  null
  
)

export default component.exports